module.exports = __webpack_public_path__ + "img/jijian.7619684.svg";